import { render, staticRenderFns } from "./HideResultsSticker.vue?vue&type=template&id=396e09c6&"
import script from "./HideResultsSticker.vue?vue&type=script&lang=js&"
export * from "./HideResultsSticker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports